import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 text-sm font-medium text-white"
      data-testid="language-switcher"
      aria-label={`Switch to ${language === 'fr' ? 'English' : 'Français'}`}
    >
      <span className={`${language === 'fr' ? 'opacity-100' : 'opacity-50'}`}>FR</span>
      <span className="text-white/40">|</span>
      <span className={`${language === 'en' ? 'opacity-100' : 'opacity-50'}`}>EN</span>
    </button>
  );
};

export default LanguageSwitcher;
